import { bool, string, func, object, number } from 'prop-types'
import { ConnectedAvatar } from '../Avatar/ConnectedAvatar'
import Pill from '../Pill'
import { Timestamp } from '../Timestamp'
import { kuiperClassNames } from '../utils'
import { withOnRestoreTracking, withOnSelectTracking } from './AnalyticsEvents'
import DeleteButton from './DeleteButton'
import RestoreButton from './RestoreButton'

import './styles.scss'

const VersionListItem = ({
  current,
  editable,
  onDelete,
  onRestore,
  onSelect,
  restorable,
  restoring = false,
  selectable,
  selected,
  skeleton,
  timestamp,
  userId,
  username,
  versionId,
  versionNumber,
}) => {
  const buttonProps = {
    current,
    editable,
    onDelete,
    onRestore: withOnRestoreTracking(onRestore, { versionNumber }),
    restorable,
    restoring,
    selected,
    versionNumber,
  }
  const classes = kuiperClassNames('version-list-item', {
    current,
    editable,
    restoring,
    selectable,
    selected,
    skeleton,
  })
  let passthroughProps = {}
  if (!skeleton) {
    passthroughProps = {
      label: versionNumber,
      timestamp,
      editable,
      tooltip: {
        content: username,
        themeClass: 'light',
      },
      name: username,
      userId,
    }
  }
  const onSelectAndTrack = withOnSelectTracking(onSelect, {
    versionId,
    versionNumber,
  })
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={classes} onClick={onSelectAndTrack}>
      <Pill {...passthroughProps} />
      <Timestamp
        {...passthroughProps}
        theme={'light'}
        messageIfMissing="Currently editing ..."
      />
      <div className={kuiperClassNames('right-container')}>
        <RestoreButton {...buttonProps} />
        <DeleteButton {...buttonProps} />
        <ConnectedAvatar size={28} {...passthroughProps} />
      </div>
    </div>
  )
}

VersionListItem.propTypes = {
  current: bool,
  editable: bool,
  onDelete: func,
  onRestore: func,
  onSelect: func,
  restorable: bool,
  restoring: bool,
  selectable: bool,
  selected: bool,
  skeleton: bool,
  timestamp: object,
  userId: string,
  username: string.isRequired,
  versionId: number,
  versionNumber: number,
}

export default VersionListItem
